import { defineMessages } from "react-intl"

export const messages = defineMessages({
    "is_archived": {
        id: "stock_imports.listing.isArchived",
        defaultMessage: "Is Archived",
    },
    "created_at": {
        id: "stock_imports.listing.filters.date.created_at",
        defaultMessage: "Created date",
    },
    "status": {
        id: "stock_imports.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "status_filter_placeholder": {
        id: "stock_imports.listing.status_filter_placeholder",
        defaultMessage: "Filter by status",
    },
    "most_used_filters": {
        id: "stock_imports.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
})


// WEBPACK FOOTER //
// ./src/common/search-filter/search/stockimportFilters/messages.ts